// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__1dz4m","cell":"ColumnAccessor_cell__18SgG","firstCellAccent":"ColumnAccessor_firstCellAccent__2fhW4"};